import React, { useState, useEffect, useMemo, useRef } from 'react'
import _ from 'lodash'
import './index.css'

const ClickOutsideDetector = ({ children, onOutsideClick }) => {
  const wrapperRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onOutsideClick()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onOutsideClick])

  return <span ref={wrapperRef}>{children}</span>
}

const ALL_OPTION_KEY = '__all__'

const normalizeString = str => str.toLowerCase().trim()

const SelectSchoolInput = ({ id, schools, value, setInputValue, setState, disabled, allOptionLabel }) => {
  // Texto da busca; `null` significa "sem busca ativa" e exibe a lista completa.
  const [search, setSearch] = useState(null)
  const [showList, setShowList] = useState(false)

  // A opção "Todas" (value null = sem filtro de escola) é opt-in e sempre encabeça a lista.
  // A lista é derivada das props porque `schools` chega por fetch depois da montagem.
  const list = useMemo(() => {
    const options = allOptionLabel
      ? [{ key: ALL_OPTION_KEY, value: null, label: allOptionLabel }, ...schools]
      : schools

    if (search === null) {
      return options
    }

    return options.filter(item => normalizeString(item.label).includes(normalizeString(search)))
  }, [schools, allOptionLabel, search])

  const handleInputChange = e => {
    const { value } = e.target

    setInputValue(value)
    setSearch(value)
  }

  const handleSchoolSelect = school => {
    setState(school.value)
    setInputValue(school.label)
    setSearch(null)
    setShowList(false)
  }

  const handleResetSearch = () => {
    setSearch(null)
    setInputValue(allOptionLabel ?? '')
    setShowList(false)
    setState(null)
  }

  return (
    <ClickOutsideDetector onOutsideClick={() => setShowList(false)}>
      <input
        id={id}
        className="summary__school-filter"
        type="text"
        value={value}
        placeholder="Selecione uma escola"
        onFocus={() => setShowList(true)}
        onChange={e => handleInputChange(e)}
        disabled={disabled}
      />
      {showList && (
        <div className="school-list">
          <div>
            {!list.length ? (
              <div>
                <button className="school-list__item" onClick={() => handleResetSearch()}>
                  Nenhum resultado
                </button>
              </div>
            ) : (
              list.map(school => (
                <div key={school.key}>
                  <button
                    onClick={() => handleSchoolSelect(school)}
                    className={
                      school.key === ALL_OPTION_KEY ? 'school-list__item school-list__item--all' : 'school-list__item'
                    }
                  >
                    {school.label}
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </ClickOutsideDetector>
  )
}

export default SelectSchoolInput

